
import apiClient from "./api";


export const DeleteAccount = async (accountId) => {
  try {
    const response = await apiClient.delete(`/api/accounts/${accountId}`);
    return response.data;
  } catch (error) {
    throw new Error("Erreur lors de la suppression du compte.",error);
  }
};
